import { inject, Pipe, PipeTransform } from '@angular/core';
import { TransactionType } from '@gs/shared';
import { TranslateService } from '@ngx-translate/core';
import { GsSelectItem } from 'libs/shared/src/controllers/gs-select/models/select-item';

@Pipe({
  name: 'mapTransactionValues',
  standalone: true
})
export class MapTransactionValuesPipe implements PipeTransform {
  // Services
  private readonly translate: TranslateService = inject(TranslateService);

  text: Record<TransactionType, string> = {
    [TransactionType.SHIPPING]: this.translate.instant('pipes.transactiontype.shipping'),
    [TransactionType.CLICK_AND_COLLECT]: this.translate.instant('pipes.transactiontype.clickAndCollect'),
    [TransactionType.RADIUS_DELIVERY]: this.translate.instant('pipes.transactiontype.radiusDelivery'),
    [TransactionType.DOWNLOAD]: this.translate.instant('pipes.transactiontype.download'),
    [TransactionType.CASHDESC]: this.translate.instant('pipes.transactiontype.cashDesc')
  };

  transform(value: Array<TransactionType>, selectedItem?: TransactionType): Array<GsSelectItem> {
    return value.map((item) => {
      return {
        text: this.text[item],
        value: item,
        selected: item == selectedItem
      } as GsSelectItem;
    });
  }
}
